import { Loader2 } from 'lucide-react';

interface IFullScreenLoaderProps {
  title: string;
  subtitle?: string;
}

function FullScreenLoader(props: IFullScreenLoaderProps) {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm z-50">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-white/70" />
        <p className="text-lg font-medium text-white/80">{props.title}</p>
        <p className="text-lg font-medium text-white/80">{props.subtitle ?? ''}</p>
      </div>
    </div>
  );
}

export default FullScreenLoader;
